<template>
  <div>
    <model-table
      ref="assignUserEmployeeJobTypes"
      title="Employee Job Types"
      add-label="Employee Job Type"
      edit-label="Edit"
      submodel
      :filter-by-data-array="userEmployeeJobTypes"
      :collection="user.userEmployeeJobTypes"
      :columns="[
        { name: 'name', field: userJob => userJob.employeeJobType.name },
        { name: 'hourly rate', component: 'money', field: userJob => userJob.hourlyRate, style: userJob => userJob.hasHourlyRateOverride ? 'color: blue' : '' },
        { name: 'default hourly rate', component: 'money', field: userJob => userJob.employeeJobType.hourlyRate },
        { name: 'default', field: 'default', component: 'checkbox' },
        { name: 'actions', align: 'right' }
      ]"
      :show-add="$isPermitted($permissions.Team.Manage)"
      @add="$refs.assignUserEmployeeJobTypes.show()"
    >
      <user-employee-job-type-form
        :user="user"
        submodel
        @on-close="userJob => checkForDefault(userJob)"
      />
    </model-table>

    <assign-user-employee-job-types
      ref="assignUserEmployeeJobTypes"
      :user="user"
    />
  </div>
</template>

<script>
import User from 'src/models/user/User'
import ModelTable from 'src/modules/admin/components/ModelTable'
import AssignUserEmployeeJobTypes from 'src/modules/admin/user/AssignUserEmployeeJobTypes'
import UserEmployeeJobTypeForm from 'src/modules/admin/user/UserEmployeeJobTypeForm'

export default {
  name: 'UserEmployeeJobTypesTable',
  components: {
    ModelTable,
    AssignUserEmployeeJobTypes,
    UserEmployeeJobTypeForm
  },
  configuration: ['currentSite'],
  props: {
    user: {
      type: User,
      required: true
    }
  },
  computed: {
    userEmployeeJobTypes () {
      const jobTypesForSite = _.filter(this.user.userEmployeeJobTypes.data, userJob => {
        return userJob.employeeJobType.siteId === this.currentSite.id
      })

      return jobTypesForSite
    }
  },
  methods: {
    checkForDefault (userJob) {
      if (userJob.default) {
        _.each(this.userEmployeeJobTypes, jobType => {
          if (jobType.id !== userJob.id) {
            jobType.default = false
          }
        })
      }
    }
  }
}
</script>
